export default __webpack_public_path__ + "static/media/harveyKlein.91acd314.jpg";